import styled, { css } from 'styled-components'

export const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.rem(12, 8)};

  button {
    &.swiper-button-lock {
      display: none;
    }
  }
`

export const NavScrollbar = styled.div`
  width: 100%;
  height: 1px;
  margin-right: ${({ theme }) => theme.rem(16)};
  margin-left: ${({ theme }) => theme.rem(16)};
  background-color: ${({ theme }) => theme.colors.primary.light5};

  .swiper-scrollbar-drag {
    background-color: ${({ theme }) => theme.colors.primary.default};
    opacity: 0.5;
  }

  ${({ theme }) =>
    theme.mediaQuery.md(`
    width: ${theme.rem(350)};
  `)}
`

export const StyledArrowButton = styled.div`
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`
